import { render, staticRenderFns } from "./CeramicsContent.vue?vue&type=template&id=52cd5868&scoped=true&"
import script from "./CeramicsContent.vue?vue&type=script&lang=js&"
export * from "./CeramicsContent.vue?vue&type=script&lang=js&"
import style0 from "./CeramicsContent.vue?vue&type=style&index=0&id=52cd5868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd5868",
  null
  
)

export default component.exports